{
  "version": 1,
  "asset_id": "b718f786-d90f-40a7-aa53-a8845ba0910d",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/b718f786-d90f-40a7-aa53-a8845ba0910d/opt_metodo-5.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/b718f786-d90f-40a7-aa53-a8845ba0910d/opt_metodo-5.jpg",
  "original_filename": "opt_metodo-5.jpg",
  "size": 86781,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:33:40Z"
}
